import { Schema } from '.';

const fepNonLinear: Schema = [
  {
    name: 'USER_ID',
    type: 'STRING',
    mode: 'REQUIRED',
    nomap: true,
  },
  {
    name: 'GROUP_ID',
    type: 'STRING',
    mode: 'REQUIRED',
    nomap: true,
  },
  {
    name: 'INGEST_ID',
    type: 'STRING',
    mode: 'REQUIRED',
    nomap: true,
  },
  {
    name: 'DELETED',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
  },
  {
    name: 'CURRENCY_PAIR',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    mode: 'NULLABLE',
    name: 'CURRENCY_1',
    type: 'STRING',
  },
  {
    mode: 'NULLABLE',
    name: 'CURRENCY_2',
    type: 'STRING',
  },
  {
    name: 'TENOR',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    mode: 'NULLABLE',
    name: 'TENOR1',
    type: 'STRING',
  },
  {
    mode: 'NULLABLE',
    name: 'TENOR2',
    type: 'STRING',
  },
  {
    name: 'TRADE_DATETIME',
    type: 'DATETIME',
    mode: 'NULLABLE',
  },
  {
    mode: 'NULLABLE',
    name: 'VALUE_DATE',
    type: 'FLOAT',
  },
  {
    mode: 'NULLABLE',
    name: 'MATURITY_DATE',
    type: 'FLOAT',
  },
  {
    name: 'CUT_TIMEZONE',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'STRATEGY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DELTA_STRIKE_PRICE',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'SIDE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SECTOR',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'PREMIUM_ACCOUNT',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'PREMIUM_CURRENCY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'NOTIONAL_AMOUNT',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'TIME_ZONE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'STRIKE_PRICE_DELTA',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'OPTION_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'GAMMA',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'IMPLIED_VOLATILITY',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'VEGA',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'IS_DELIVERABLE',
    type: 'BOOLEAN',
    mode: 'NULLABLE',
  },
  {
    name: 'BENCHMARK',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'EXPLICIT_COST',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SECURITY_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SECURITY_SUB_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'INSTRUMENT_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DESCRIPTION',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADER_NAME_ID_CODE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DESK_LOCATION',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'COVER_PRICE',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'LIMIT_PRICE',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_SIZE',
    type: 'INTEGER',
    mode: 'NULLABLE',
  },
  {
    name: 'EVENT_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'INSTRUCTIONS',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'PM',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'ACCOUNT',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'FUND',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DEALER_BROKER',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'PLATFORM_VENUE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'OTHER_IDS',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_1',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
].sort((a, b) => {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
});

export default fepNonLinear;
